import { Breadcrumb } from '@repo/ui/components/ui/breadcrumb';
import { Card } from '@repo/ui/components/ui/card';
import { GroupeDetail } from '@repo/ui/features/groupe/groupe-detail';
import { PageHeader } from '@repo/ui/ui/layout/page-header';
import { useNavigate, useParams } from 'react-router-dom';

export default function GroupeDetailPage() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const goToList = () => navigate('/admin/droits/groupe');

  if (!id) {
    return <div className="p-4 text-destructive">ID du groupe manquant</div>;
  }

  return (
    <div className="space-y-4">
      <div className="mb-2">
        <Breadcrumb
          items={[
            { label: 'Gestion' },
            { label: 'Groupes', href: '/admin/droits/groupe' },
            { label: 'Détail du groupe', current: true },
          ]}
          showHomeIcon
          onHomeClick={() => navigate('/admin/dashboard')}
          className="mb-4"
        />
      </div>

      <PageHeader>
        <PageHeader.Title>Détail du Groupe</PageHeader.Title>
      </PageHeader>

      <Card className="p-4">
        <GroupeDetail
          groupeId={parseInt(id, 10)}
          onBack={goToList}
          onEdit={() => navigate(`/admin/droits/groupe/${id}/edit`)}
        />
      </Card>
    </div>
  );
}
